import Moment from 'moment';
import GoogleMaps from './googleMaps';
import Icons from './icons';
import State from './state';

/**
 * This is old code from our original jquery base store locator...
 *
 */
export default {
    /**
   * Determine if a store is Level 1-3
   * @param  object  store
   * @return boolean
   */
    isLevel (store) {
        return store._isPerformanceLab || store._isPerformanceStudio || store._isPerformanceCenter ||
      store._isCertified || store._isPremier || store._isCore || store._isOther;
    },

    phone (store) {
        if (!store.phone) return '';

        return store.phone;
    },

    /**
   * Calculate the distance between a store and the location center
   * @param  object store
   * @return string
   */
    distance (store) {
        const loc = GoogleMaps.getLocationFromLatLng(store.latitude, store.longitude);
        const dist = Math.round(GoogleMaps.getDistanceFromCenter(loc));

        if (dist !== 0) {
            return `${dist} ${State.distancePref} ${State.awayText}`;
        }

        return '';
    },

    /**
   * Generate the HTML used within the google maps view
   * @param  object store
   * @return string
   */
    createInfoBoxHtml (store) {
        let html = '';
        // var rating = '';
        console.log(store);

        const levelName = function (store) {
            if (store._isPremier) return 'Premier';
            if (store._isCertified) return 'Certified';
            if (store._isCore) return 'Core';

            return 'Retailer';
        };

        const markerUrl = function (store) {
            if (State.appRegion === 'us') {
                if (store._isKingdom) return Icons.getPath('REYNOLDS', 'label');
                if (store._isPremier) return Icons.getPath('PREM', 'label');
                if (store._isCertified) return Icons.getPath('CERT', 'label');
                if (store._isCore) return Icons.getPath('CORE', 'label');

                return Icons.getPath('RETAIL', 'label');
            }

            if (State.appRegion === 'eu') {
                if (store._isPerformanceLab) return Icons.getPath('TMPL', 'label');
                if (store._isPerformanceCenter) return Icons.getPath('TMPC', 'label');
                if (store._isPerformanceStudio) return Icons.getPath('TMPS', 'label');
                if (store._isSelectFit) return Icons.getPath('SELECT', 'label');
            }

            // if (store._isOther) return Icons.getPath('RETAL', 'label');

            return Icons.getPath('RETAIL', 'label');
        };

        const storeTitle = State.appRegion === 'us' ? `${levelName(store).toUpperCase()}<br />` : '';

        html = `
      <div class="mapContent">
        <div class="store">

          <div class="store-list-logo">
            ${
    store._isKingdom ? `
              <span>
                <img src="${markerUrl(store)}" alt="" /><br />
              </span>
            ` : ''
} ${this.isLevel(store) && (store._isPremier || store._isCertified || store._isCore) && !store._isKingdom ? `
              <span>
                ${storeTitle}
                <img src="${markerUrl(store)}" alt="" /><br />
              </span>
              ` : ''}${store._isFittingEvent && !store._isKingdom ? `
              <span>
                <img src="${Icons.getPath('FITTING', 'label')}" alt="" />
              </span>
              ` : ''
}${store._isNFC ? `
              <span>
                <img src="${Icons.getPath('NFC', 'label')}" alt="" /><br />
              </span>
              ` : ''
}${store._isAmbassador ? `
              <span>
                <img src="${Icons.getPath('AMBASSADOR', 'label')}" alt="" /><br />
              </span>
              ` : ''
}
          </div>

          <div class="store-list-details">
            <div class="location-name">${store.name}</div>
            ${store.address1}, ${store.city}, ${store.stateCode} ${store.postalCode}
            ${store._locationType ? `
            <div>
              <strong>${store._locationType}</strong>
            </div>` : ''}

            ${store._isFittingEvent ? `
            <div class="book-now">
              <strong>Event Details:</strong>
              ${store.storeEvents}
              <br />
              ${this.phone(store) ? 'Call this location: <strong>' + this.phone(store) + '</strong>' : ''} 
            </div>
            ` : `
            <div class="location-phone">
            ${this.phone(store)}
            </div>`}

          </div>

        </div>
      </div>
    `;

        return html;
    },

    /**
   * Set the store varibles to true/false based on their supplied values
   *
   * Logic for US:
   * Prem + FittingLoc = Prem
   * Prem + Other + FittingLoc = Prem + National Fitting Center
   * Cert + FittingLoc = Certified
   * Other + FittingLoc = Core
   * FittingLoc = Retailer on the fitting list
   *
   *
   * @param array data
   */

    setStoreStatus (data, state) {
        for (let i = 0; i < data.length; i++) {
            data[i]._locationType = null;
            data[i]._isPerformanceLab = !!(data[i].isPerformanceLabLocation && data[i].isFittingLocation !== '');
            data[i]._isPerformanceStudio = !!(data[i].isStudioLocation && data[i].isFittingLocation !== '');
            data[i]._isPerformanceCenter = !!(data[i].isFittingCenterLocation && data[i].isFittingLocation !== '');
            data[i]._isSelectFit = !!(data[i].isSelectFitLocation && data[i].isFittingLocation !== '');
            data[i]._isFitter = !!(data[i].isFittingLocation && data[i].isFittingLocation !== '');
            data[i]._isPremier = !!(data[i].isPremierLocation && data[i].isPremierLocation !== '');
            data[i]._isCertified = !!(data[i].isCertifiedLocation && data[i].isCertifiedLocation !== '');

            if (state.searchType === 'fittinglocation' || state.searchType === 'fittingevent') {
                console.log(state.searchType, data[i], data[i].isFittingLocation !== '', (!data[i]._isCertified && !data[i]._isPremier && !data[i]._isSelectFit && !data[i]._isPerformanceCenter && !data[i]._isPerformanceStudio && !data[i]._isPerformanceLab));
                data[i]._isCore = !!(data[i].isFittingLocation !== '' && (!data[i]._isCertified && !data[i]._isPremier && !data[i]._isSelectFit && !data[i]._isPerformanceCenter && !data[i]._isPerformanceStudio && !data[i]._isPerformanceLab));
            } else {
                data[i]._isOther = !!(data[i].isOtherLocation && data[i].isOtherLocation !== '');
            }

            if (State.appRegion === 'eu') {
                data[i]._isPremier = !!(data[i]._isPerformanceLab || data[i]._isPerformanceStudio || data[i]._isPerformanceCenter);
                data[i]._isCertified = !!data[i]._isSelectFit;
            }

            if (State.appRegion === 'au') {
                data[i]._locationType = 'Authorised Stockist';
            }

            data[i]._isFittingEvent = false;

            if (data[i].storeEvents) {
                data[i]._isFittingEvent = true;
            }

            // if (State.appRegion === 'us' && data[i].storeEvents) {
            //     data[i]._isFittingEvent = data[i].storeEvents.indexOf('myFittingExp') > 0 || data[i].storeEvents.indexOf('myfittingexp') > 0;
            // }

            // if (State.appRegion === 'eu' && data[i].storeEvents) {
            //     data[i]._isFittingEvent = data[i].storeEvents.length > 0;
            // } else if (State.appRegion === 'eu') {
            //     data[i]._isFittingEvent = false;
            // }

            data[i]._isKingdom = data[i].name.indexOf('KINGDOM AT REYNOLDS PLANTATION') >= 0;
            data[i]._isNFC = data[i].isNFC;
            data[i]._isAmbassador = data[i].isAmbassadorLocation;

            // if (State.appRegion === 'us') {
            if (data[i]._isFittingEvent) {
                data[i].storeEvents = this.cleanStoreData(data[i].storeEvents);

                if (data[i].storeEvents === '') {
                    data[i]._isFittingEvent = false;
                }
            }                
            // }

            if (data[i].customEvents) {
                data[i]._isFittingEvent = true;
                data[i]._isFitter = true;
            } 
        }

        return data;
    },

    /**
   * Clean up the store data with regards to ball fittings
   * <p>04/13/2019 10:00AM-02:30PM (Ball Fittings)--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/24JJ\" target=\"_blank\" event-product-type=\"ball\">Book an Appointment</a><br/>04/13/2019 03:00PM-04:00PM--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/DRBB\" target=\"_blank\">Book an Appointment</a></p>
   */
    cleanStoreData (data) {
        const stores = data.replace('<p>', '').replace('</p>', '').replace(/ \(Ball Fittings\)/g, '').split('<br/>');

        for (let i = 0; i < stores.length; i++) {
            stores[i] = stores[i].replace('--', '<br />');
            stores[i] = stores[i].replace(/<a/g, '<a class="btn btn-sm btn-tertiary"')
            ;

            if (stores[i].indexOf('ball') > 0) {
                stores[i] = stores[i].replace('Book an Appointment', 'Book Ball Fitting Appointment');
            }
        }

        return stores.join(''); //this.removeOldEvents(stores);
    },

    /**
   * Determine if Fitting even is Today, or has past
   * @param  string event string
   * @return string
   *
   * Sample:
   * <p>02/10/2017 03:00PM-07:00PM--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/Oov\">Book an Appointment</a><br/>03/10/2017 03:00PM-07:00PM--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/yGM\">Book an Appointment</a><br/>04/14/2017 03:00PM-07:00PM--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/8YX\">Book an Appointment</a></p>
   * <p>04/13/2019 10:00AM-02:30PM (Ball Fittings)--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/24JJ\" target=\"_blank\" event-product-type=\"ball\">Book an Appointment</a><br/>04/13/2019 03:00PM-04:00PM--<a href=\"https://my.taylormadegolf.com/myFittingExp/event/DRBB\" target=\"_blank\">Book an Appointment</a></p>
   */
    removeOldEvents (stores) {
        const today = new Moment();
        let eventString = '';

        for (let i = 0; i < stores.length; i++) {
            const eventDataDuplicate = stores[i];
            let eventData = stores[i];
            eventData = eventData.split('<br />');

            const eventDateAsMomentObj = new Moment(eventData[0], 'MM/DD/YYYY');

            if (today.isSame(eventDateAsMomentObj, 'day') || !today.isAfter(eventDateAsMomentObj)) {
                eventString += `<br />${eventDataDuplicate}`;
            }
        }

        return eventString;
    },
    // removeOldEvents(str) {
    //   var today = Moment();
    //   var cleanedStr = str.replace('<p>', '').replace('</p>', '');
    //   var eventString = '';
    //   var eventArray = cleanedStr.split('<br/>');

    //   for (var i = 0; i < eventArray.length; i++) {
    //     var eventDataDuplicate = eventArray[i];
    //     var eventData = eventArray[i];
    //     if (eventData.indexOf('Ball Fittings') > 0) {
    //       eventData = eventData.substring(0, eventData.indexOf(' (Ball Fittings)--'));
    //     } else {
    //       eventData = eventData.substring(0, eventData.indexOf('--<'));
    //     }
    //     eventData = eventData.split(' ');

    //     var eventDateAsMomentObj = Moment(eventData[0], "MM/DD/YYYY");

    //     if (today.isSame(eventDateAsMomentObj, 'day') || !today.isAfter(eventDateAsMomentObj)) {
    //       eventString += '<br />' + eventDataDuplicate;
    //     }
    //   }

    //   return eventString;
    // },

    /**
   * Determine which image marker URL should be used for a location
   * @param  object store
   * @param  boolean showOnMap
   * @return string
   */
    markerUrl (store, showOnMap) {
        let url = null;

        if (showOnMap) {
            if (State.appRegion === 'us') {
                if (store._isOther) url = Icons.getPath('RETAIL', 'pin');
                if (store._isOther && store._isFittingEvent) url = Icons.getPath('RETAIL', 'event_pin');

                if (store._isCore) url = Icons.getPath('CORE', 'pin');
                if (store._isCore && store._isFittingEvent) url = Icons.getPath('CORE', 'event_pin');

                if (store._isCertified) url = Icons.getPath('CERT', 'pin');
                if (store._isCertified && store._isFittingEvent) url = Icons.getPath('CERT', 'event_pin');

                if (store._isPremier) url = Icons.getPath('PREM', 'pin');
                if (store._isPremier && store._isFittingEvent) url = Icons.getPath('PREM', 'event_pin');

                if (!url && store._isFittingEvent) url = Icons.getPath('FITTING', 'pin');

                if (!url) url = Icons.getPath('RETAIL', 'pin');

                if (store._isKingdom) url = Icons.getPath('REYNOLDS', 'pin');
            }

            if (State.appRegion === 'eu') {
                if (store._isPerformanceLab) url = Icons.getPath('TMPL', 'pin');
                if (store._isPerformanceLab && store._isFittingEvent) url = Icons.getPath('TMPL', 'event_pin');

                if (store._isPerformanceCenter) url = Icons.getPath('TMPC', 'pin');
                if (store._isPerformanceCenter && store._isFittingEvent) url = Icons.getPath('TMPC', 'event_pin');

                if (store._isPerformanceStudio) url = Icons.getPath('TMPS', 'pin');
                if (store._isPerformanceStudio && store._isFittingEvent) url = Icons.getPath('TMPS', 'event_pin');

                if (store._isSelectFit) url = Icons.getPath('SELECT', 'pin');
                if (store._isSelectFit && store._isFittingEvent) url = Icons.getPath('SELECT', 'event_pin');

                if (!url && store._isFittingEvent) url = Icons.getPath('FITTING', 'pin');

                if (!url) url = Icons.getPath('RETAIL', 'pin');
            }
        } else {
            url = Icons.getPath('RETAIL', 'pin');
        }

        return url;
    }
};
